/**Se utiliza un map de key/value para rastrear de manera rápida la url 
 * y devolver el slug correspondiente para utilizar en la landing */
export const mapUrl = new Map<string, string>();
mapUrl.set("192.168.0.72:4200","asociacion-espanola"); 
mapUrl.set("localhost:4200",'centro-medico-integral-rosario-cmir'); 
mapUrl.set("ilanding.red-i.com.ar","mo");
mapUrl.set("asocespaniola.com.ar","asociacion-espanola");
mapUrl.set("idemo.red-i.com.ar",'centro-medico-integral-rosario-cmir');
mapUrl.set("espaciomo.ar",'mo');
mapUrl.set("www.espaciomo.ar",'mo');
mapUrl.set("amesalud.ar","asociacion-espanola");
mapUrl.set("idev.red-i.kozaca.com.ar","centro-medico-integral-rosario-cmir"); 
mapUrl.set("romamedicinaestetica.com.ar","roma-medicina-estetica");
mapUrl.set("www.romamedicinaestetica.com.ar","roma-medicina-estetica")
mapUrl.set("172.18.0.1:4200","centro-medico-integral-rosario-cmir"); 
